import { useDataChange, useDataValue } from 'Simple/Data'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let image_serie_id = useDataValue({
    context: 'images_comparison_action',
    path: 'image_serie_id',
    viewPath: props.viewPath,
  })
  let image_id = useDataValue({
    context: 'images_comparison_action',
    path: 'image_id',
    viewPath: props.viewPath,
  })
  let index = useDataValue({
    context: 'images_comparison_action_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'images_comparison_sections',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    change(next => {
      next.images[index].image_serie_id = image_serie_id
      next.images[index].image_id = image_id
    })

    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
